import logger from 'loglevel';
import { getCurrentDate } from './currentDate';

logger.setLevel('warn') // set a default level
const methods = ['trace', 'debug', 'info', 'warn', 'error'];

function log(level, prefix) {
    const logLevel = level.toUpperCase();
    return (msg) => {
        logger[level](`${getCurrentDate()}|${logLevel}|${prefix}|${msg}`);
    };
}

export function create(classname) {
    return methods.reduce((aggr, method) => (
        Object.assign(
            { [method]: log(method, classname) },
            aggr,
        )
    ), {});
}

export const setLevel = logger.setLevel;



// WEBPACK FOOTER //
// /src/js/common/utils/logger.js